import React, { useContext, useEffect, useState } from 'react'
import CardStep from '../../../../../components/modalStepper/step/CardStep'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { MakeRequestContext } from '../../MakeRequestContext'
import { othersEnum, subCategoryEnum } from '../../../../../enums/makeRequestEnum'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'
import { propertyLabel, propertyType, requestPurpose } from '../../../../../enums/contractsEnum'
import fr from '../../../../../translations/fr'
import { Grid, Theme } from '@material-ui/core'
import SvgSchemaTechnique from './schemaTechnique/SchemaTechnique'
import { getCategorieDemandeTechnique } from '../../../../../enums/demandesTechniqueEnum'
import PopinDemandeTechnique from './PopinDemandeTechnique'
import SvgPoint from '../../../../../icons/SvgPoint'
import SvgSchemaTechniqueMobile from './schemaTechnique/SchemaTechniqueMobile'
import { CONTRACT } from '../step2/RequestPurpose'

const useStyle = makeStyles<Theme, {isLargeScreen: boolean}>(
    (theme) => (
        {
            ...styles(theme),
            cardContainerStyle: {
                width: '100%',
                margin: 0
            },
            divOther: {
                display: 'flex',
                width: '100%'
            },
            guideLink: {
                color: theme.gecina.green,
                marginBottom: 20,
                cursor: 'pointer'
            },
            guideContainer:{
                marginBottom: 20
            },
            svgContainer: {
                width: '100%',
                zIndex: 1,
                height: 'fit-content',
                marginBottom: 20,
                '& > svg:first-child': {
                    overflow: 'visible',
                    marginBottom: props => props.isLargeScreen ? 10 : 30
                },
                '& foreignObject': {
                    backgroundColor: '#e9e7e8',
                    padding: 15
                }
            },
            legendBlue: {
                color: theme.gecina.blue
            },
            legendGreen: {
                color: theme.gecina.green
            },
            legendePrisEnCompte: {
               width:  props => props.isLargeScreen ? '95%' : '85%',
            },
            legendClass: {
                marginLeft: 20,
                marginBottom: 10
            },
        }
    )
)


// Sous-catégorie conservée dans subCategoryEnum pour l'affichage des demandes déjà
// créées, mais retirée des choix proposés au locataire.
const SOUS_CATEGORIE_MASQUEE = 'requestParking'

const RequestConcern = () => {
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )
    const classes = useStyle({isLargeScreen})
    const theme = useTheme()
    const {request, nextStep} = useContext(MakeRequestContext)
    const subCategory = subCategoryEnum[request.requestPurpose as keyof typeof subCategoryEnum]
    const cartes = Object.getOwnPropertyNames(subCategory)
        .filter((card) => !(request.requestPurpose === CONTRACT && card === SOUS_CATEGORIE_MASQUEE))
    const [seeOthers, setSeeOthers] = useState<boolean>(false)
    const othersArray: string[] = othersEnum[request.requestPurpose as keyof typeof othersEnum] || []
    const others: string = 'others'
    const [open, setOpen] = useState<boolean>(false)
    const [selectedDemandeTechnique, setSelectedDemandeTechnique] = useState<string>("")
    const [popinPosisiton, setPopinPosisiton] = useState<{ x: number, y: number }>({ x: 0, y: 0 })
    const svgRef = React.useRef<SVGSVGElement | null>(null);
    const [priseEnChargeTotal, setPriseEnChargeTotal] = useState<boolean>(false)
    const [meuble, setMeuble] = useState<boolean>(false)

    useEffect(() => {
        let contratDate: Date | null | undefined
        const dateJour = new Date()

        if (Array.isArray(request.contract)) {
            contratDate = request.contract[0].dateEffet
            setMeuble(request.contract[0].meuble)
        } else {
            contratDate = request.contract?.dateEffet
            setMeuble(request.contract?.meuble ?? false)
        }
        setPriseEnChargeTotal((contratDate && dateJour <= new Date(contratDate.setDate(contratDate.getDate() + 30))) || false)
    }, [request])

    const cardContainerClass: ClassValue = classNames(
        'row',
        {
            [classes.cardContainerStyle]: !isLargeScreen
        }
    )

    const legendeBailleurClass = classNames(
        classes.text7,
        classes.legendClass,
        {
            [classes.legendGreen]: !priseEnChargeTotal,
            [classes.legendePrisEnCompte]: priseEnChargeTotal
        }
    )

    const legendeLocatifClass = classNames(
        classes.text7,
        classes.legendClass,
        classes.legendBlue
    )

    const getBlocDescription = (card: string) => {

        return (
            <>
                <h2 className={classes.text7}>
                    <FormattedMessage
                        id={`requests.makeRequest.step3.${card}`}
                        defaultMessage={card}
                        description="Card description"
                    />
                </h2>
            </>
        )
    }

    const updateRequestConcern = (text: string) => {
        request.requestConcern = text

        saveInteractions(
            {
                category: 'Vos Demandes',
                action: 'Déposer une demande',
                // @ts-ignore
                label: `Etape 4::Bien concerné::${request.contract?.type === propertyType.apartment ? propertyLabel.apartment : request.contract?.type === propertyType.local ? propertyLabel.local : propertyLabel.garage}::${fr[`requests.makeRequest.step1.${request.requestType}`]}::${fr[`requests.makeRequest.step2.${request.requestPurpose}`]}::${fr[`requests.makeRequest.step3.${text}`]}`
            }
        )

        nextStep()
    }

    const onClickSchemaTechnique = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        const svg = svgRef.current;
        const targetId = (event.target as Element).id
        if (targetId && svg) {
            if (targetId === "cross") {
                setOpen(false)
                setSelectedDemandeTechnique("")
            } else {
                setSelectedDemandeTechnique(getCategorieDemandeTechnique(targetId))
                setOpen(true)
                const svgWidth = svg.viewBox.baseVal.width || svg.clientWidth
                const svgHeight = svg.viewBox.baseVal.height || svg.clientHeight

                const rightThreshold = svgWidth * 0.6
                const bottomThreshold = svgHeight * 0.6

                const point = svg.createSVGPoint()
                point.x = event.clientX
                point.y = event.clientY

                // Transform to SVG coordinates
                const svgPoint = point.matrixTransform(svg.getScreenCTM()?.inverse())
                const position = {
                    x: svgPoint.x >= rightThreshold ? svgPoint.x - 400 : svgPoint.x,
                    y: svgPoint.y >= bottomThreshold ? svgPoint.y - 300 : svgPoint.y
                }
                setPopinPosisiton(position)
            }
        } else if ((event.target as Element).tagName !== "foreignObject" && (event.target as Element).tagName !== "DIV") {
            setOpen(false)
            setSelectedDemandeTechnique("")
        }
        event.persist()
    }

    const onMouseOverSchemaTechnique = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        const svg = svgRef.current;
        const targetId = (event.target as Element).id
        if (targetId && svg) {
            if (targetId !== "cross") {
                setSelectedDemandeTechnique(getCategorieDemandeTechnique(targetId))
                setOpen(true)
                const svgWidth = svg.viewBox.baseVal.width || svg.clientWidth
                const svgHeight = svg.viewBox.baseVal.height || svg.clientHeight

                const rightThreshold = svgWidth * 0.6
                const bottomThreshold = svgHeight * 0.6

                const point = svg.createSVGPoint()
                point.x = event.clientX
                point.y = event.clientY

                // Transform to SVG coordinates
                const svgPoint = point.matrixTransform(svg.getScreenCTM()?.inverse())
                const position = {
                    x: svgPoint.x >= rightThreshold ? svgPoint.x - 400 : svgPoint.x,
                    y: svgPoint.y >= bottomThreshold ? svgPoint.y - 300 : svgPoint.y
                }
                setPopinPosisiton(position)
            }
        }
    }

    return (
        <Grid>
            <Grid>
                <div className={cardContainerClass}>
                    {request.requestPurpose === requestPurpose.private ?
	                    <Grid className={classes.svgContainer}>
                            {isLargeScreen ?
                                <SvgSchemaTechnique
                                    svgRef={svgRef}
                                    onClick={(event) => onClickSchemaTechnique(event)}
                                    onMouseOver={(event) => onMouseOverSchemaTechnique(event)}
                                    positionPin={popinPosisiton}
                                    popinOpen={open}
                                    priseEnChargeBailleur={priseEnChargeTotal}
                                    meuble={meuble}
                                >
                                    <PopinDemandeTechnique
                                        selectedDemandeTechnique={selectedDemandeTechnique}
                                        priseEnChargeBailleur={priseEnChargeTotal}
                                        setSelected={() => updateRequestConcern(selectedDemandeTechnique)}
                                    />
                                </SvgSchemaTechnique>
                                :
                                <SvgSchemaTechniqueMobile
                                    svgRef={svgRef}
                                    onClick={(event) => onClickSchemaTechnique(event)}
                                    positionPin={popinPosisiton}
                                    popinOpen={open}
                                    priseEnChargeBailleur={priseEnChargeTotal}
                                    meuble={meuble}
                                >
                                    <PopinDemandeTechnique
                                        selectedDemandeTechnique={selectedDemandeTechnique}
                                        priseEnChargeBailleur={priseEnChargeTotal}
                                        setSelected={() => updateRequestConcern(selectedDemandeTechnique)}
                                    />
                                </SvgSchemaTechniqueMobile>
                            }
							<Grid container item>
								{priseEnChargeTotal ?
									<></>
									:
									<>
	                                    <Grid container item xs={12}>
	                                        <Grid item>
	                                            <SvgPoint color={theme.gecina.blue} />
	                                        </Grid>
	                                        <Grid item className={legendeLocatifClass}>
	                                            <FormattedMessage
	                                                id="requests.makeRequest.step3.private.legende.locatif"
	                                                defaultMessage="LA CHARGE DE YOUFIRST"
	                                                description="Legende locatif"
	                                            />
	                                        </Grid>
	                                    </Grid>
	                                    <Grid container item xs={12}>
	                                        <Grid item>
	                                            <SvgPoint color={theme.gecina.green} />
	                                        </Grid>
	                                        <Grid item className={legendeBailleurClass}>
	                                            <FormattedMessage
	                                                id="requests.makeRequest.step3.private.legende.bailleur"
	                                                defaultMessage="À VOTRE CHARGE"
	                                                description="Legende bailleur"
	                                            />
	                                        </Grid>
	                                    </Grid>
                                    </>
								}
							</Grid>
	                    </Grid>
                        :
                        <>
                            {
                                cartes.map(
                                    (card) => (
                                        <React.Fragment key={card}>
                                            {
                                                !othersArray.includes(card) &&
                                                <CardStep
                                                    blocDescription={getBlocDescription(card)}
                                                    setSelected={() => updateRequestConcern(card)}
                                                />
                                            }
                                        </React.Fragment>
                                    )
                                )
                            }
                            {
                                othersArray.length > 0 &&
                                <div className={classes.divOther}>
                                    <CardStep
                                        blocDescription={getBlocDescription(others)}
                                        setSelected={() => setSeeOthers(!seeOthers)}
                                        isOther={seeOthers}
                                    />
                                </div>
                            }
                            {
                                cartes.map(
                                    (card) => (
                                        <React.Fragment key={card}>
                                            {
                                                seeOthers && othersArray.includes(card) &&
                                                <CardStep
                                                    blocDescription={getBlocDescription(card)}
                                                    setSelected={() => updateRequestConcern(card)}
                                                />
                                            }
                                        </React.Fragment>
                                    )
                                )
                            }
                        </>
                    }
                </div>
            </Grid>
        </Grid>
    )
}


export default RequestConcern
